/**
 * Image presets for CaaS image optimisation API.
 * https://sph.atlassian.net/wiki/spaces/PAPP/pages/1664090132/CaaS+image+optimisation+API#Presets
 * */
export enum ImagePresets {
  MICRO = 240,
  SMALL = 360,
  MEDIUM = 480,
  LARGE = 960,
  XLARGE = 1920,
}
